module.exports = __webpack_public_path__ + "0ab883a971f7b26c95a3fedb98ff2c20.png";